var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainWarp"},[_vm._m(0),_c('div',{staticClass:"scollWarp"},[_c('div',{staticClass:"main",attrs:{"id":_vm.id}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-title"},[_c('img',{attrs:{"src":"/iconImg/h_title_bg.png"}}),_c('span',{staticClass:"DataTitle"},[_vm._v("片区流量监控")])])
}]

export { render, staticRenderFns }